export default __webpack_public_path__ + "static/media/fav.e36b519c.png";